import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { TicketsIcon } from '@/components/icons/tickets-icon';
import { AnalyticsPageCategories } from '@/enums/analytics-type';

type PresaleContentProps = {
  analyticsLinkName: string;
  children?: React.ReactNode;
  contentClassName?: string;
  headingDataTest?: string;
  iconClassName?: string;
  linkDataTest?: string;
  messageDataTest?: string;
  presaleLinkText?: string;
  presaleLinkUrl?: string;
  presaleMessage: string;
};

export const PresaleContent = ({
  analyticsLinkName,
  children,
  contentClassName = 'flex items-center gap-2',
  headingDataTest = 'presale-message-title',
  iconClassName = 'icon h-5 w-5 shrink-0 fill-destructive',
  linkDataTest = 'presale-external-link',
  messageDataTest = 'presale-message-text',
  presaleLinkText,
  presaleLinkUrl,
  presaleMessage,
}: PresaleContentProps): React.JSX.Element => {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-base md:text-md"
        data-test={headingDataTest}
      >Advance Tickets
      </h3>
      <div className={contentClassName}>
        <div className="flex items-center gap-2">
          <TicketsIcon className={iconClassName} />
          <div>
            <span className="text-sm md:text-md"
              data-test={messageDataTest}
            >{presaleMessage}
            </span>
            {presaleLinkUrl && presaleLinkText &&
              <>
                {' '}
                <CinemarkLink primary
                  useAnchor
                  dataLinkCategory={AnalyticsPageCategories.SHOWTIME_BLOCK}
                  dataLinkName={analyticsLinkName}
                  dataTest={linkDataTest}
                  href={presaleLinkUrl}
                >
                  {presaleLinkText}
                </CinemarkLink>
              </>
            }
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};
